import { ApiError } from '@/utility/apiClient'

/**
 * エラーからステータスコードを判定
 */
const getStatusCode = (error: Error): number => {
  // ApiErrorの場合はstatusを直接取得
  if (error instanceof ApiError) {
    return error.status
  }

  // それ以外の予期しないエラーはその他のエラーとして扱う
  // 400を返すことでErrorOtherが表示される
  return 400
}

export default getStatusCode
